import * as React           from "react";
import {cx}                 from "emotion";
import {useRef}             from "react";
import {useState, Fragment} from "react";
import ReactTooltip        from 'react-tooltip';

import "./specSectionFieldCreator.scss";
import "../customize-panel.scss";

import {CommentBoxWithCounter}        from "./commentBoxWithCounter";
import {Input}                        from "./input";
import {OfficeSearchField}            from "./officeSearchField";
import {PhoneFormat}                  from "./phoneFormat";
import {TinyMceField}                 from "./tinyMceField";
import {UserSearchField}              from "./userSearchField";
import {SpecSectionFieldCreatorProps} from "../../build3.d";
import * as callingList               from "./country-calling-code-list.json";
import {SliderCheckbox}               from "@Common/ui-components/slider-checkbox/slider-checkbox";
import {InformationBadge}             from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";
import {PhoneFieldPrefAndExt}         from "./custom-inputs/phoneFieldPrefAndExt";
import {PlainTextBlock}               from "./custom-inputs/plainTextBlock";
import {FiveColumnMultiField}         from "./custom-inputs/fiveColumnMultiField";
import {ThreeColumnMultiField}         from "./custom-inputs/threeColumnMultiField";


export const SpecSectionFieldCreator = ({idOrder, data, domainData, setUnsavedChanges, companyPrefs, branchDetails, error}: SpecSectionFieldCreatorProps) => {

    const editorRef = useRef([]);
    const [branchIsInternational, setBranchIsInternational] = useState(null);

    function createFields(specField) {
        let emailReg       = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i;
        let phoneFormatter = require('phone-formatter');
        let phoneOptions   = [1,2,3,4,5,6,11,12,13,14,15,16,17,21];
        let val            = specField.data;
        let defaultVal     = [specField.defaultValue];
        let emailValid     = true;
        let countable      = !specField.idTemplateFieldFormat?.split(",").includes("24") && specField.idTemplateFieldFormat?.split(",").includes("23");

        // Select options
        if(specField.idDisplayStyle == 3) {
            if(defaultVal != val){
                let optionToMove = defaultVal.splice(defaultVal.indexOf(val), 1);
                defaultVal.unshift(optionToMove[0]);
            }
        }
        let options = {};
        if (Array.isArray(defaultVal) && defaultVal.length > 0) {
            try {
                const firstItem = defaultVal[0];

                if (typeof firstItem === "string") {
                    // Try parsing if it's a JSON string
                    if (firstItem.startsWith("[")) {
                        options = JSON.parse(firstItem); // Array case
                    } else if (firstItem.startsWith("{")) {
                        options = JSON.parse(firstItem); // Object case
                    } else {
                        options = defaultVal; // Treat as normal array of strings
                    }
                }
            } catch (error) {
                //commenting console.error to cleanup console in build3
                //console.error("Invalid JSON inside array:", error);
                options = {};
            }
        }
        if(!!val && !val.startsWith("+ ") && phoneOptions.indexOf(parseInt(specField.idTemplateFieldFormat)) != -1){
            val = phoneFormatter.format(specField.data, specField.formatType.replaceAll("#","N"));
        }

        if(specField.idTemplateFieldFormat?.split(",").includes("7")){
            val = val.toLowerCase();
        }
        if(specField.idTemplateFieldFormat?.split(",").includes("8")){
            val = val.toUpperCase();
        }
        if(specField.idTemplateFieldFormat?.split(",").includes("9")){
            if(specField.data !='' && emailReg.test( specField.data ) == false )
            {
                emailValid = false;
            }
        }
        // Email domain check
        if(specField.idTemplateFieldFormat?.split(",").includes("18")){
            val = val.split("@", 1)[0]
        }


        const [fieldValue, setFieldValue] = useState(val);
        const [ckValue, setCkValue] = useState(specField.deleteField === true ? 1 : 0);
        const [labelValue, setLabelValue] = useState(specField.displayLabel);
        const [selectChoice, setSelectChoice] = useState(val);
        const [aiTextGenerating, setAiTextGenerating] = useState(false);
        const [alignmentChoice, setAlignmentChoice] = useState(specField.align);

        const setLabelHandler = (data) => {
            let curval = data?.target.value;
            setLabelValue(curval);
        }

        function deleteCheckHandler () {
            setCkValue((currVal) => currVal == 0 ? 1 : 0);
        }

        const changeHandler = (fieldFormat, data) => {
            let curval = data?.target.value;
            if(fieldFormat == "lower_case") {
                curval = curval.toLowerCase();
            }
            if(fieldFormat == "upper_case") {
                curval = curval.toUpperCase();
            }
            setUnsavedChanges();
            setFieldValue(curval)
        }
        const tooltipContent = specField.message;
        let tooltipPosition = specField.msgType?specField.msgType.replace('_tooltip', ''):'';
        //we need to reverse the position for display same as build2
        if( tooltipPosition == "left_tooltip" )
        {
            tooltipPosition = "right";
        }
        // Use a unique identifier for each tooltip based on specField's fieldKey
        const tooltipId = `tooltip-${specField.fieldKey}`;
        const replaceStr = (str) => {
            return str.replace( /(<([^>]+)>)/ig, '');
        }

        // set onChange handler for each item in data - this exposes a way to update one spec field from another field
        specField.onChange = (textValue) => setFieldValue(textValue);

        return (<>{
            specField.idDisplayStyle === 20 ?
                PlainTextBlock({specField})
        :
            specField.idDisplayStyle === 21 ?
                PhoneFieldPrefAndExt({specField, fullData: data})
        :
            specField.idDisplayStyle === 22 || specField.idDisplayStyle === 23 ?
                FiveColumnMultiField({specField, fullData: data})
        :
            specField.idDisplayStyle === 24 || specField.idDisplayStyle === 25 ?
                ThreeColumnMultiField({specField, fullData: data})
        :

            <div className={specField.idDisplayStyle == 6 ? "spec-section-field-hidden-ar6" : "spec-section-field-creator-ar6" } key={specField.fieldKey}>
                <div className={specField.idDisplayStyle == 2 ? "edit-label-and-input-instance" : "label-and-input-instance"}>
                    {specField.idDisplayStyle == 2 && (
                        <div className="check">
                                <Input
                                    inputField={specField}
                                    inputType="checkbox"
                                    fieldValue={ckValue}
                                    hidden={true}
                                    xdQaType="hidden"
                                    extraInfo={{"data-multipartfield": "deleteField"}}
                                />
                                <SliderCheckbox
                                    value={!ckValue}
                                    onChange={deleteCheckHandler}
                                    dark={true}
                                    xdQaType="checkbox"
                                    xdQaName={specField.fieldKey}
                                />
                        </div>
                    )}
                    {specField.idDisplayStyle == 4 && !["field_1", "field_2", "field_3", "field_4", "field_5"].includes(specField.fieldKey) && (
                        <>
                        <div className="label">
                            {"Align " + specField.displayLabel}
                        </div>
                        <div className={specField.idDisplayStyle == 2 ? "content-input-div" : "input"}>
                            <select
                                className="form-control"
                                value={alignmentChoice ?? ""}
                                name={"align_" + specField.fieldKey}
                                data-fieldname={specField.displayLabel}
                                xd-qa-type="dropdown"
                                xd-qa-name="Align Field 1"
                                onChange={(e) => setAlignmentChoice(e.target.value)}
                            >
                                <option key="<*L>" value="&lt;*L&gt;" xd-qa-type="dropdown_item" xd-qa-name="Left">Left</option>
                                <option key="<*C>" value="&lt;*C&gt;" xd-qa-type="dropdown_item" xd-qa-name="Center">Center</option>
                                <option key="<*R>" value="&lt;*R&gt;" xd-qa-type="dropdown_item" xd-qa-name="Right">Right</option>
                                <option key="<*J>" value="&lt;*J&gt;" xd-qa-type="dropdown_item" xd-qa-name="Justify">Justify</option>
                            </select>
                        </div></>
                    )}
                    <div className={specField.idDisplayStyle == 2 ? "content-label-div" : "label"}>
                        <div xd-qa-type="label" xd-qa-name={(specField.idDisplayStyle == 10 || specField.idDisplayStyle == 6 ) ? "" : specField.displayLabel}>
                        {specField.idDisplayStyle == 2 &&
                        (specField.displayLabel !== "•"
                        && specField.displayLabel !== '\\*'
                        && specField.displayLabel !== "&#8226;"
                        && specField.displayLabel.charCodeAt(0) !==  165
                        && specField.displayLabel.charCodeAt(0) !== 149 )
                            ? (
                            <Input
                                inputField={specField}
                                fieldValue={labelValue}
                                changeHandler={setLabelHandler.bind(this)}
                                readOnly={!!ckValue}
                                extraInfo={{"data-multipartfield": "label"}}
                                xdQaType="label"
                            />
                        ) : (specField.idDisplayStyle == 10 || specField.idDisplayStyle == 6 ) ? (
                            ""
                        ) : specField.fieldKey == 'field_90' ? (
                            "License Number (BRE)"
                        ) : (specField.displayLabel === "•"
                        || specField.displayLabel === '\\*'
                        || specField.displayLabel === "&#8226;"
                        || specField.displayLabel.charCodeAt(0) ===  165
                        || specField.displayLabel.charCodeAt(0) === 149 ) ? (
                            <div className="bullet-spec">
                                {specField.displayLabel}
                                <input
                                    type="hidden"
                                    name={specField.fieldKey}
                                    value={specField.displayLabel}
                                    data-multipartfield="label"
                                />
                            </div>
                        ) :specField.displayLabel}{specField.required ? <span className="specField-required">*</span> : ""}
                        {(specField.message && specField.msgType == "hcomment") &&
                        InformationBadge({
                            height: 20,
                            getTooltip: () =>  String(specField.message),
                            xdQaName: "tooltip hcomment"
                        })
                        }
                        </div>
                    </div>
                    <div className={specField.idDisplayStyle == 2 ? "content-input-div" : "input"} data-tip={tooltipContent} data-for={tooltipId}>
                        {specField.idDisplayStyle == 3 ?
                            <select defaultValue="" name={specField.fieldKey} value={selectChoice} onChange={() => setSelectChoice(this.value)} data-fieldname={specField.displayLabel} xd-qa-type="dropdown" xd-qa-name={"order_data["+specField.fieldKey+"][data]"}>
                                <option value="" xd-qa-type="dropdown_item" xd-qa-name="default">
                                    - Select -
                                </option>
                                {Array.isArray(options)
                                ? options.map(value => (
                                    <option key={value} value={value} xd-qa-type="dropdown_item" xd-qa-name={value}>
                                        {value}
                                    </option>
                                ))
                                : options !== null && typeof options === "object" && Object.entries(options).map(([key, value]) => (
                                    <option key={key} value={/^\d+$/.test(key) ? value : key}  xd-qa-type="dropdown_item" xd-qa-name={value}>
                                        {value}
                                    </option>
                                ))}
                            </select>
                        : specField.idDisplayStyle == 4 ?
                            <TinyMceField
                                idOrder={idOrder}
                                fieldId={specField.idPrimary}
                                fieldValue={fieldValue}
                                setFieldValue={setFieldValue}
                                fieldData={specField}
                                editorRef={editorRef}
                                aiTextGenerating={aiTextGenerating}
                                setAiTextGenerating={setAiTextGenerating}
                                companyPrefs={companyPrefs}
                                replaceStr={replaceStr}
                            />
                        : specField.idDisplayStyle == 11 ?
                            <CommentBoxWithCounter
                                idOrder={idOrder}
                                fieldData={specField}
                                fieldValue={fieldValue}
                                setFieldValue={setFieldValue}
                                aiTextGenerating={aiTextGenerating}
                                setAiTextGenerating={setAiTextGenerating}
                                companyPrefs={companyPrefs}
                                replaceStr={replaceStr}
                            />
                        : specField.idDisplayStyle == 10 || specField.idDisplayStyle == 6 ?
                            <Input
                                inputField={specField}
                                inputFieldName={specField.fieldKey}
                                inputType="hidden"
                                fieldValue={fieldValue}
                                xdQaType="hidden"
                            />
                        : specField.idDisplayStyle == 9 ?
                            <><OfficeSearchField
                                onlyOffice={true}
                                labelname={specField.displayLabel}
                                value={fieldValue}
                                xdQAType="text_field"
                                xdQAValue={specField.fieldKey}
                                data={data}
                                contentGroup={specField.contentGroup}
                                displayGroup={specField.displayGroup}
                                setBranchIsInternational={setBranchIsInternational}
                                fieldKey={specField.fieldKey}
                            />
                            <Input
                                inputField={specField}
                                inputFieldName={specField.fieldKey}
                                inputType="hidden"
                                fieldValue={fieldValue}
                                xdQaType="hidden"
                            /></>
                        : specField.idDisplayStyle == 2 ?
                            specField.fieldFormatName?.startsWith("phone_") || specField.fieldFormatName=='domestic_vs_international' || specField.fieldFormatName=='smart_phone' ?
                                <PhoneFormat
                                    specField={specField}
                                    val={fieldValue}
                                    smartPhoneList={callingList?.default}
                                    branchIsInternational={branchIsInternational == null ? val.startsWith("+ ") ? true : !['United States', 'US', 'USA', 'Canada', 'CA'].includes(branchDetails?.branchCountry) : branchIsInternational}
                                    error={error}
                                    countable={countable}
                                    readonlyVal={!!ckValue}
                                />
                                :   <Input
                                        inputField={specField}
                                        dataFieldName={labelValue}
                                        fieldValue={fieldValue}
                                        className={cx({ countable, error: (error && fieldValue == '' && specField.required) })}
                                        changeHandler={changeHandler.bind(this, specField?.fieldFormatName)}
                                        readOnly={!!ckValue}
                                        extraInfo={{ "data-multipartfield": "data" }}
                                    />

                        : specField.idDisplayStyle == 8 ?
                            <><UserSearchField
                                labelname={specField.displayLabel}
                                value={fieldValue}
                                xdQAType="text_field"
                                xdQAValue={specField.fieldKey}
                                data={data}
                                contentGroup={specField.contentGroup}
                                displayGroup={specField.displayGroup}
                            />
                            <Input
                                inputField={specField}
                                inputFieldName={specField.fieldKey}
                                inputType="hidden"
                                fieldValue={fieldValue}
                                xdQaType="hidden"
                            /></>
                        : specField.fieldFormatName?.startsWith("phone_") || specField.fieldFormatName=='domestic_vs_international' || specField.fieldFormatName=='smart_phone' ?
                            branchDetails && <PhoneFormat
                                specField={specField}
                                val={fieldValue}
                                smartPhoneList={callingList?.default}
                                branchIsInternational={branchIsInternational == null ? val.startsWith("+ ") ? true : !['United States','US','USA','Canada','CA'].includes(branchDetails?.branchCountry) : branchIsInternational}
                                error={error}
                                countable={countable}
                                readonlyVal={specField.idDisplayStyle == 7}
                            />
                        : specField.idTemplateFieldFormat?.split(",").includes("18") ?
                            <Input
                                inputField={specField}
                                fieldValue={fieldValue}
                                className={cx({countable, error: (error && fieldValue == '' && specField.required)})}
                                changeHandler={changeHandler.bind(this,specField?.fieldFormatName)}
                                extraInfo={{"data-combinefield": "combineDataField"}}
                            />
                        :
                            <Input
                                inputField={specField}
                                fieldValue={fieldValue}
                                className={cx({countable, error: (error && fieldValue == '' && specField.required)})}
                                changeHandler={changeHandler.bind(this,specField?.fieldFormatName)}
                                readOnly={!specField.isEditable || specField.idDisplayStyle == 7}
                                data-tip={(specField.message ? specField.message :"")}
                            />
                        }
                       {(specField.message && specField.msgType !== "hcomment") &&
                            <ReactTooltip
                                id={tooltipId}
                                place={tooltipPosition}
                                effect="solid"
                                type="dark"
                            />
                        }
                        {specField.idTemplateFieldFormat?.split(",").includes("18") && <>
                            <p>{domainData.assignDomain}</p>
                            <Input
                                inputField={specField}
                                inputType="hidden"
                                fieldValue={domainData.assignDomain}
                                xdQaType="hidden"
                                extraInfo={{"data-combinefield": "data"}}
                            />
                        </>}

                    </div>
                </div>
            </div>
        }</>)
    }

    return data.map((field) => {
        return (
            <Fragment key={field.fieldKey}>
                {createFields(field)}
            </Fragment>
        );
    });

};